import { urlEncode } from '@services/Url';

const serializeFormData = data => ({
  contentGuidString: data.contentGuidString,
  title: data.title,
  summary: data.summary,
  cite: data.cite,
  ctaLabel: data.ctaLabel,
  ctaUrl: data.ctaUrl,
  issueDate: data.issueDate,
  addedDate: data.addedDate,
  createdDate: data.createdDate,
  createdBy: data.createdBy,
});

const eBarBoardOfProfessionalsCreate = async (data) => {
  const eBarCreate = await fetch('/EBarBoardOfProfessionalsCallToActionBlock/CreateEpiBoardOfProfessionals', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarCreateJson = eBarCreate.json();

  return eBarCreateJson;
};

const eBarBoardOfProfessionalsUpdate = async (data) => {
  const eBarUpdate = await fetch('/EBarBoardOfProfessionalsCallToActionBlock/UpdateEpiBoardOfProfessionals', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      input: JSON.stringify(serializeFormData(data)),
    }),
  });
  const eBarUpdateJson = eBarUpdate.json();

  return eBarUpdateJson;
};

const eBarBoardOfProfessionalsDelete = async (data) => {
  const eBarDelete = await fetch('/EBarBoardOfProfessionalsCallToActionBlock/DeleteEpiBoardOfProfessionals', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: urlEncode({
      stringToDelete: data,
    }),
  });
  const eBarDeleteJson = eBarDelete.json();

  return eBarDeleteJson;
};


export {
  eBarBoardOfProfessionalsCreate,
  eBarBoardOfProfessionalsUpdate,
  eBarBoardOfProfessionalsDelete,
};
